export const SKIN_TONE_NEUTRAL = 'neutral';
export const SKIN_TONE_LIGHT = '1f3fb';
export const SKIN_TONE_MEDIUM_LIGHT = '1f3fc';
export const SKIN_TONE_MEDIUM = '1f3fe';
export const SKIN_TONE_MEDIUM_DARK = '1f3ff';
export const SKIN_TONE_DARK = '1f3fd';
export const DATA_NAME = 'tones';
